
//  https://github.com/ivoputzer/m.uuid
const uuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16)) // replaces zeroes, ones, and eights with random hex digits
}

export default uuid
